import { defineBlocksWithJsonArray } from 'blockly/core';

import { beginnerTimeField } from '../helpers/block-builders.js';
import { beginnerPinField } from '../pins/pin-selector.js';
import {
  BEGINNER_MELODY_OPTIONS,
  BEGINNER_NOTE_OPTIONS,
  BEGINNER_OCTAVE_OPTIONS,
} from './sound-constants.js';

const SOUND_STYLE = 'beginner_sound_blocks';

const passiveBuzzerBlockDefinitions = [
  {
    type: 'beginner_passive_buzzer_play_note',
    message0: 'play note %1 octave %2 on pin %3 for %4',
    args0: [
      {
        type: 'field_dropdown',
        name: 'NOTE',
        options: BEGINNER_NOTE_OPTIONS,
      },
      {
        type: 'field_dropdown',
        name: 'OCTAVE',
        options: BEGINNER_OCTAVE_OPTIONS,
      },
      beginnerPinField('BUZZER_PIN', 'buzzer'),
      beginnerTimeField('DURATION', { value: 0.5 }),
    ],
    previousStatement: null,
    nextStatement: null,
    style: SOUND_STYLE,
    tooltip: 'Plays a musical note on a passive buzzer.',
    helpUrl: '',
  },
  {
    type: 'beginner_passive_buzzer_play_melody',
    message0: 'play melody %1 on pin %2',
    args0: [
      {
        type: 'field_dropdown',
        name: 'MELODY',
        options: BEGINNER_MELODY_OPTIONS,
      },
      beginnerPinField('BUZZER_PIN', 'buzzer'),
    ],
    previousStatement: null,
    nextStatement: null,
    style: SOUND_STYLE,
    tooltip: 'Plays a built-in melody on a passive buzzer.',
    helpUrl: '',
  },
  {
    type: 'beginner_passive_buzzer_stop',
    message0: 'stop sound on pin %1',
    args0: [beginnerPinField('BUZZER_PIN', 'buzzer')],
    previousStatement: null,
    nextStatement: null,
    style: SOUND_STYLE,
    tooltip: 'Stops the sound on a passive buzzer.',
    helpUrl: '',
  },
];

export function registerBeginnerPassiveBuzzerBlocks(): void {
  defineBlocksWithJsonArray(passiveBuzzerBlockDefinitions);
}
